/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { VistaControllerRespondMutationRequest, VistaControllerRespondMutationResponse, VistaControllerRespondPathParams, VistaControllerRespond400, VistaControllerRespond401, VistaControllerRespond403 } from "../../models/changeOrdersController/VistaControllerRespond";

function getVistaControllerRespondUrl(id: VistaControllerRespondPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/potential-change-orders/${id}/vista/owner-response` as const }  
  return res
}

/**
 * {@link /api/v1/potential-change-orders/:id/vista/owner-response}
 */
export async function vistaControllerRespond(id: VistaControllerRespondPathParams["id"], data: VistaControllerRespondMutationRequest, config: Partial<RequestConfig<VistaControllerRespondMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<VistaControllerRespondMutationResponse, ResponseErrorConfig<VistaControllerRespond400 | VistaControllerRespond401 | VistaControllerRespond403>, VistaControllerRespondMutationRequest>({ method : "POST", url : getVistaControllerRespondUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}